var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isMobile
        ? _c(
            "v-dialog",
            {
              attrs: { fullscreen: "" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "primary white--text",
                      class: { title: !_vm.isMobile, subheading: _vm.isMobile }
                    },
                    [
                      _vm._v("\n        User Preferences\n        "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "white--text",
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v("\n          close\n        ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.showLoading
                    ? _c(
                        "v-list",
                        { attrs: { "two-line": "" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    { staticClass: "primary--text" },
                                    [
                                      _vm._v(
                                        "\n              Tooltips: Helpful hints throughout the app\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n              Click the star to turn tooltips OFF and ON.\n            "
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-action",
                                { on: { click: _vm.toggleTooltip } },
                                [
                                  _vm.showTooltip === "enabled"
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "secondary" } },
                                            [_vm._v("star")]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        [_c("v-icon", [_vm._v("star_border")])],
                                        1
                                      )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.userPreferencesArray &&
                          _vm.userPreferencesArray.length
                            ? [
                                _c("v-divider"),
                                _vm._v(" "),
                                _vm._l(_vm.userPreferencesArray, function(
                                  preference,
                                  i
                                ) {
                                  return _c(
                                    "span",
                                    { key: i },
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c(
                                                "v-list-tile-title",
                                                {
                                                  staticClass: "primary--text"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        preference.displayName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                  Select this to have the " +
                                                    _vm._s(
                                                      preference.displayName
                                                    ) +
                                                    "\n                  as your default view on login.\n                "
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.setUserPreference(
                                                    preference.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.defaultView ==
                                              preference.value
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "secondary"
                                                          }
                                                        },
                                                        [_vm._v("star")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "span",
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("star_border")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      i < _vm.userPreferencesArray.length - 1
                                        ? _c("span", [_c("v-divider")], 1)
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { type: "error", value: _vm.errorMsg } },
                    [_vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.showLoading
                    ? _c(
                        "div",
                        { staticClass: "text-xs-center py-3" },
                        [_c("loading-spinner")],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "v-dialog",
            {
              attrs: { width: "700" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "primary white--text",
                      class: { title: !_vm.isMobile, subheading: _vm.isMobile }
                    },
                    [_vm._v("\n        User Preferences\n      ")]
                  ),
                  _vm._v(" "),
                  !_vm.showLoading
                    ? _c(
                        "v-list",
                        { attrs: { "two-line": "" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    { staticClass: "primary--text font-bold" },
                                    [
                                      _vm._v(
                                        "\n              Tooltips: Helpful hints throughout the app\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n              Click the star to turn tooltips OFF and ON.\n            "
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-action",
                                { on: { click: _vm.toggleTooltip } },
                                [
                                  _vm.showTooltip === "enabled"
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "secondary" } },
                                            [_vm._v("star")]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        [_c("v-icon", [_vm._v("star_border")])],
                                        1
                                      )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.userPreferencesArray &&
                          _vm.userPreferencesArray.length
                            ? [
                                _c("v-divider"),
                                _vm._v(" "),
                                _vm._l(_vm.userPreferencesArray, function(
                                  preference,
                                  i
                                ) {
                                  return _c(
                                    "span",
                                    { key: i },
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c(
                                                "v-list-tile-title",
                                                {
                                                  staticClass:
                                                    "primary--text font-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        preference.displayName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                  Select this to have the " +
                                                    _vm._s(
                                                      preference.displayName
                                                    ) +
                                                    "\n                  as your default view on login.\n                "
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.setUserPreference(
                                                    preference.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.defaultView ==
                                              preference.value
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "secondary"
                                                          }
                                                        },
                                                        [_vm._v("star")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "span",
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("star_border")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      i < _vm.userPreferencesArray.length - 1
                                        ? _c("span", [_c("v-divider")], 1)
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { type: "error", value: _vm.errorMsg } },
                    [_vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.showLoading
                    ? _c(
                        "div",
                        { staticClass: "text-xs-center py-3" },
                        [_c("loading-spinner")],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17126d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17126d06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-preferences.vue
// module id = null
// module chunks = 